var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGpsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.19 27.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        opacity: .7;\n      }\n\n      .cls-2 {\n        fill: #2d3e50;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.59,0c.71,0,1.27.57,1.27,1.27v2.2c4.61.57,8.27,4.23,8.84,8.84h2.2c.71,0,1.27.57,1.27,1.27s-.57,1.27-1.27,1.27h-2.2c-.57,4.61-4.23,8.27-8.84,8.84v2.2c0,.71-.57,1.27-1.27,1.27s-1.27-.57-1.27-1.27v-2.2c-4.61-.57-8.27-4.23-8.84-8.84H1.27c-.71,0-1.27-.57-1.27-1.27s.57-1.27,1.27-1.27h2.2c.57-4.61,4.23-8.27,8.84-8.84V1.27c0-.71.57-1.27,1.27-1.27ZM5.95,13.59c0,2.73,1.46,5.26,3.82,6.62s5.28,1.37,7.65,0,3.82-3.89,3.82-6.62-1.46-5.26-3.82-6.62-5.28-1.37-7.65,0-3.82,3.89-3.82,6.62ZM8.5,13.59c0-1.82.97-3.5,2.55-4.42,1.58-.91,3.52-.91,5.1,0,1.58.91,2.55,2.59,2.55,4.42s-.97,3.5-2.55,4.42c-1.58.91-3.52.91-5.1,0-1.58-.91-2.55-2.59-2.55-4.42ZM16.14,13.59c0-.91-.49-1.75-1.27-2.21-.79-.46-1.76-.46-2.55,0-.79.46-1.27,1.3-1.27,2.21s.49,1.75,1.27,2.21c.79.46,1.76.46,2.55,0,.79-.46,1.27-1.3,1.27-2.21Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpsIcon);
export default __webpack_public_path__ + "static/media/gps_icon.2a4e42e74503a5a3987b791b240bbe0d.svg";
export { ForwardRef as ReactComponent };